<div class="p-6 flex-table-page" data-testid="return-exception-page">
  <app-search-form
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex flex-wrap items-center gap-2">
      @if (canApprove()) {
        <app-button
          type="success"
          [outlined]="true"
          icon="check"
          [label]="'return_exception.actions.bulk_approve' | translate"
          [disabled]="pendingSelectedCount() === 0 || actionLoading()"
          (emitOnClick)="onBulkApprove()"
        />
      }
      @if (canCancel()) {
        <app-button
          type="danger"
          [outlined]="true"
          icon="close"
          [label]="'return_exception.actions.bulk_cancel' | translate"
          [disabled]="pendingSelectedCount() === 0 || actionLoading()"
          (emitOnClick)="onBulkCancel()"
        />
      }
      <app-button
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      />
    </div>
  </app-search-form>

  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      [dataSource]="items()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      [hasCheckColumn]="canApprove() || canCancel()"
      [selection]="selectedItems()"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    >
      <ng-template #statusTemplate let-status>
        <p-tag
          [value]="getStatusLabel(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
        />
      </ng-template>

      <ng-template #customTemplate let-value let-column="column">
        @if (column?.prop === 'creationDate') {
          <span class="text-sm">{{ formatDateTime(value) }}</span>
        } @else {
          {{ value }}
        }
      </ng-template>

      <ng-template #actionsTemplate let-record>
        <div class="flex items-center justify-center gap-2 whitespace-nowrap w-full">
          @if (canView()) {
            <app-button
              class="action-view"
              [label]="'common.actions.view' | translate"
              type="action"
              (emitOnClick)="onView(record); $event.stopPropagation()"
            />
          }
          @if (canApprove() && isPending(record)) {
            <app-button
              [label]="'return_exception.actions.approve' | translate"
              type="action"
              (emitOnClick)="onApprove(record); $event.stopPropagation()"
            />
          }
          @if (canCancel() && isPending(record)) {
            <app-button
              [label]="'return_exception.actions.cancel' | translate"
              type="action"
              (emitOnClick)="onCancel(record); $event.stopPropagation()"
            />
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast />

<app-confirmation-dialog
  [visible]="showConfirmationDialog()"
  (visibleChange)="showConfirmationDialog.set($event)"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
/>
